<template>
    <section class="row flexbox-container">
  <div class="col-xl-8 col-11 d-flex justify-content-center">
      <div class="card bg-authentication rounded-0 mb-0">
          <div class="row m-0">
              <div class="col-lg-6 d-lg-block d-none text-center align-self-center px-1 py-0">
                  <img src="images/pages/login.png" width="500px" alt="branding logo">
              </div>
              <div class="col-lg-6 col-12 p-0">
                  <div class="card rounded-0 mb-0 px-2">
                      <div class="card-header pb-1">
                          <div class="card-title" style="margin-top: 60px;">
                              <h4 class="mb-0">{{trans('auth.login')}}</h4>
                          </div>
                      </div>
                      <p class="px-2">Welcome back, please login to your account.</p>
                      <div class="card-content">
                          <div class="card-body pt-1">
                            <form id="loginform" @submit.prevent="submit" @keydown="loginForm.errors.clear($event.target.name)">
                              <fieldset class="form-label-group form-group position-relative has-icon-left">

                                  <input type="text" name="username" class="form-control" :class="{ 'is-invalid': loginForm.errors.has('username') }" :placeholder="trans('auth.username')" v-model="loginForm.username">
                            

                                  <div class="form-control-position">
                                      <i class="feather icon-user"></i>
                                  </div>
                                  <label for="username">{{ trans('auth.username') }}</label>
                                    

                                      <show-error :form-name="loginForm" prop-name="username"></show-error>
 
                              </fieldset>

                              <fieldset class="form-label-group position-relative has-icon-left">

                                  <input type="password" name="password" class="form-control" :class="{ 'is-invalid': loginForm.errors.has('password') }" :placeholder="trans('auth.password')" v-model="loginForm.password">

                                  <div class="form-control-position">
                                      <i class="feather icon-lock"></i>
                                  </div>
                                  <label for="password">{{ trans('auth.password') }}</label>
                                  <show-error :form-name="loginForm" prop-name="password"></show-error>
                                    
                              </fieldset>
                              <div class="form-group d-flex justify-content-between align-items-center">
                                  <div class="text-left">
                                    <div class="g-recaptcha" v-if="getConfig('recaptcha') && getConfig('login_recaptcha')" :data-sitekey="getConfig('recaptcha_key')"></div>
                                  </div>
                                  
                                    <!-- <div v-if="getConfig('reset_password')" class="text-right">
                                        <router-link to="/password" class="card-link">{{trans('auth.reset_here!')}}</router-link>
                                    </div> -->
                                    <div class="text-right">
                                        <router-link to="/reset-default" class="card-link">
                                            First time login? Reset default password
                                        </router-link>
                                    </div>
                                    

                              </div>
                              <router-link to="/register" class="btn btn-outline-primary float-left btn-inline" v-if="getConfig('registration')">{{trans('auth.register')}}</router-link>
                              <button-spinner
                                    :is-loading="loginForm.isLoading" 
                                    :disabled="loginForm.isLoading"
                                    
                                    class="btn btn-primary float-right btn-inline"
                                    style="height: 39px; color: #fff;"
                                    >
                                    {{trans('auth.login')}}
                                </button-spinner>
                            </form>
                          </div>
                      </div>
                      <div class="login-footer">
                        <div class="divider">
                          <div class="divider-text">OR</div>
                        </div>
                        <div class="footer-btn d-inline">
                              <router-link to="/pay-tax" class="btn btn-outline-primary btn-inline" v-if="getConfig('registration')">Pay Tax</router-link>
                              <button type="button" class="btn btn-outline-primary float-right btn-inline">Tax Calculator</button>
                        </div>
                      </div>
                      <!-- <div class="login-footer">
                        <div class="divider" v-if="getConfig('social_login')">
                          <div class="divider-text">OR</div>
                        </div>
                        <div class="footer-btn d-inline" v-if="getConfig('social_login')">
                            <a v-for="provider in social_login_providers" v-if="getConfig(provider+'_login')" :href="`/auth/social/${provider}`" :class="['btn','btn-'+provider]" v-tooltip="trans('auth.login_with',{type:provider})"> <span :class="['fab','fa-'+provider]"></span></a>
                        </div>
                      </div> -->
                  </div>
              </div>
          </div>
      </div>
      <div class="modal fade" id="notification" tabindex="-1" role="dialog" aria-labelledby="notificationDetails" aria-hidden="true" style="display: none;">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title" id="notificationDetails">Notice</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                    </div>
                    <div class="modal-body">
                        <p>Dear Taxpayers,</p>
                        <p>We wish to notify you of our ETax portal currently being upgraded. You can log in to your existing profile using your State TaxID as default username and a default password as "<strong>password</strong>" which we advise you to update accordingly.</p>
                        <p>You can pay your taxes, levies, fines, and charges online from your comfort zone, as well as file your annual returns and request for Tax Clearance Certificate.</p>
                        <p>For any inquiry or support fell free to contact us via <a href="#">info@irs.sk.gov.ng</a> or call <a href="#">+234 708 534 9849</a>.</p>
                        <p>
                            Thank you.
                        </p>
                        
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-danger waves-effect text-left" data-dismiss="modal">{{trans('general.close')}}</button>
                    </div>
                </div>
            </div>
        </div>
  </div>
</section>
    
</template>

<script>
    import guestFooter from '../../layouts/guest-footer.vue'

    export default {
        data() {
            return {
                loginForm: new Form({
                    isLoading: false,
                    username: '',
                    password: ''
                }),
                social_login_providers: []
            }
        },
        components: {
            guestFooter
        },
        mounted(){
            if(helper.getConfig('social_login'))
            axios.get('/api/configuration/variable?type=social_login')
                .then(response => response.data)
                .then(response => {
                    this.social_login_providers = response.social_login_providers;
                })
                .catch(error => {
                    helper.showDataErrorMsg(error);
                });
                $('#notification').modal('show');
        },
        methods: {
            submit(){
                this.loginForm.isLoading = true;
                this.loginForm.post('/api/auth/login')
                    .then(response =>  {
                        localStorage.setItem('auth_token',response.token);
                        axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('auth_token');
                        this.$store.dispatch('setAuthStatus');
                        this.$store.dispatch('setLastActivity');
                        this.loginForm.isLoading = false;
                        toastr.success(response.message);

                        if(helper.getConfig('two_factor_security') && response.two_factor_code){
                            this.$store.dispatch('setTwoFactorCode',response.two_factor_code);
                            this.$router.push('/auth/security');
                        }
                        else {
                            var redirect_path = response.reload ? '/home?reload=1' : '/home';
                            this.$store.dispatch('resetTwoFactorCode');
                            this.$router.push(redirect_path);
                        }
                    }).catch(error => {
                        this.loginForm.isLoading = false;
                        helper.showErrorMsg(error);
                        toastr.error(error.message);
                    });
            },
            loginAsAdmin(){
                this.loginForm.username = 'john.doe@example.com';
                this.loginForm.password = 'password';
                this.submit();
            },
            loginAsUser(){
                this.loginForm.username = 'marry.jen@example.com';
                this.loginForm.password = 'password';
                this.submit();
            },
            getConfig(config){
                return helper.getConfig(config);
            }
        }
    }
</script>
